


















import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'
import ChartHeader from './ChartHeader.vue'

@Component({
  name: 'BarDashedLine',
  components: { Chart, ChartHeader }

})
export default class extends Vue {
  @Prop({}) private dataList!: any
  @Prop({}) private colorList!: any
  // 超过多少个开始滚动
  @Prop({ default: null }) private scrollNumber!: number | null
  // 单个数据增加的滚动内容宽度 px
  @Prop({ default: 0 }) private scrollItemWidth!: number

  // @Prop({ default: '#00B66C' }) private color!: string

  private chartId: string = ''
  private legend: any[] = []
  private valLength: number = 0
  private option: any = {
    animation: false,
    color: this.colorList,
    // legend: {},
    dataZoom: [
    ],
    grid: {
      top: 20,
      right: 10,
      left: 30,
      bottom: 80
    },
    xAxis: {
      type: 'category',
      data: [],
      splitLine: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        formatter: (value:any) => {
          return this.$fn.substring(value, 5)
        }
      },
      offset: 10
    },
    yAxis: {
      type: 'value',
      splitLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisLabel: {
        color: '#999999'
      },
      max: 102
    },
    series: []
  }

  get chart() {
    return this.$refs.chart as any
  }
  @Watch('dataList', { immediate: true, deep: true })
  onDataChange(val: any) {
    if (!this.dataList.length) return
    if (this.dataList.length >= 6) {
      // console.log('设置DataZoom')
      this.option.dataZoom = [
        {
          bottom: 0,
          type: 'slider',
          startValue: 0,
          endValue: 5,
          backgroundColor: '#fff',
          fillerColor: '#eee',
          dataBackground: {
            lineStyle: {
              color: '#fff'
            },
            areaStyle: {
              color: '#fff'
            }
          }
        }]
    } else {
      // console.log('取消DataZoom')
      this.option.dataZoom = null
    }
    // console.log('> dataList: ', this.dataList)
    this.valLength = this.dataList[0].values.length
    this.legend = this.dataList[0].valueDescs.map((item:any, index:any) => {
      return {
        name: item,
        color: this.colorList[index]
      }
    }) || []
    let names = this.dataList.map((item:any) => item.name)
    let valNames = this.dataList[0].valueDescs || []
    this.option.xAxis.data = names

    let seriesItemTemp = {
      name: '',
      type: 'bar',
      barWidth: 12,
      stack: 'stack',
      label: {
        rotate: 45
      },
      data: [],
      itemStyle: {
        normal: {
          borderColor: '#fff',
          borderWidth: 1
        }
      },
      markLine: {
        symbol: 'none',
        lineStyle: {
          type: 'dotted',
          color: '#aeaeae'
        },
        data: []
      }
    }
    let series:any[] = []

    // console.log('valLength:' + this.valLength)
    for (let i = 0; i < this.valLength; i++) {
      let temp = JSON.parse(JSON.stringify(seriesItemTemp))
      temp.name = valNames[i]
      temp.data = this.dataList.map((item:any) => item.values[i])
      series.push(temp)
    }
    // console.log(series)

    series.map((item, index) => {
      if (index === 0) return // 不画第一条线
      let markLineData:any = []
      names.map((name:any, nameIndex:any) => {
        if (nameIndex === names.length - 1) return
        if (nameIndex === names.length - 1) return
        markLineData.push([
          {
            coord: [name, this._sum(this.dataList[nameIndex].values, index)]
          },
          {
            coord: [names[nameIndex + 1], this._sum(this.dataList[nameIndex + 1].values, index)]
          }
        ])
      })
      item.markLine.data = markLineData
    })
    // console.log(series)
    this.option.series = series

    // console.log(JSON.stringify(series.map(item => item.markLine.data)))
    // console.log(JSON.stringify(series))
    this.$nextTick(() => {
      this.chart.setOption(this.option)
    })
  }

  /**
   * 对数组前N项求和
   * @param arr
   * @param index
   */
  private _sum(arr:any[], index:number) {
    if (index === 0) return 0
    if (index === 1) return arr[0]
    arr = arr.map((item:string) => {
      return parseFloat(item)
    })
    return arr.slice(0, index).reduce((a:number, b:number) => a + b)
  }
  created() {
    this.chartId = new Date().getTime() + '_' + parseInt(Math.random() * 10000000 + '')
  }
}
